// WelkomBiz Photography — shared static data for Phase 1.
// Designed for easy replacement in later phases (real galleries, DB-driven events, etc.)

export const LOGO_FULL = "/brand/wb_full.png";
export const LOGO_MARK = "/brand/wb_mark.png";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Events", to: "/events" },
  { label: "Hire Us", to: "/hire" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  { title: "Event Photography", icon: "Camera", desc: "Full-coverage storytelling for moments that matter." },
  { title: "Sports Photography", icon: "Activity", desc: "Frozen action, raw emotion, precise timing." },
  { title: "Corporate Events", icon: "Briefcase", desc: "Polished imagery for brands & conferences." },
  { title: "Weddings & Engagements", icon: "Heart", desc: "Cinematic love stories, captured forever." },
  { title: "Matric Farewells", icon: "Sparkles", desc: "A night of elegance, immortalised in frames." },
  { title: "Baby Showers", icon: "Baby", desc: "Soft, warm coverage of life’s first chapters." },
  { title: "Individual Photoshoots", icon: "User", desc: "Portraits with depth, mood and personality." },
  { title: "Business & Lodge", icon: "Building2", desc: "Premium visuals for properties & brands." },
  { title: "Promotional Videos", icon: "Film", desc: "Cinematic edits crafted to convert." },
  { title: "Business Intro Videos", icon: "Play", desc: "First impressions that command attention." },
  { title: "Event Videos", icon: "Video", desc: "Highlight reels that feel like film trailers." },
];

export const VIDEO_SERVICES = [
  { title: "Business Videos", icon: "Briefcase" },
  { title: "Lodge Videos", icon: "Mountain" },
  { title: "Promotional Videos", icon: "Megaphone" },
  { title: "Event Videos", icon: "Video" },
  { title: "Social Media Content", icon: "Share2" },
];

export const WHY_CHOOSE = [
  { title: "Top-quality photography", desc: "Pro-grade equipment, refined editing standard.", icon: "Award" },
  { title: "Professional event coverage", desc: "Discreet, prepared, always on schedule.", icon: "ShieldCheck" },
  { title: "Premium editing style", desc: "A consistent cinematic colour signature.", icon: "Wand2" },
  { title: "Fast & organised galleries", desc: "Browse, select, download — beautifully laid out.", icon: "FolderOpen" },
  { title: "Creative visual storytelling", desc: "We frame narratives, not just photos.", icon: "BookOpen" },
  { title: "Photography & video solutions", desc: "Stills and motion under one creative roof.", icon: "Layers" },
  { title: "Local Goldfields focus", desc: "Proudly serving the Free State & beyond.", icon: "MapPin" },
  { title: "Modern client experience", desc: "Stylish booking, seamless delivery.", icon: "Star" },
];

// Sample / demo event data for Phase 1
export const FEATURED_EVENTS = [
  {
    id: "evt-goldfields-sports-2025",
    title: "Goldfields Sports Event",
    category: "Sports",
    date: "15 March 2025",
    desc: "Provincial finals — sprint heats, podium moments, raw athletic energy.",
    image: "https://images.unsplash.com/photo-1471295253337-3ceaaedca402?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-corporate-function-2025",
    title: "Corporate Annual Function",
    category: "Corporate",
    date: "28 April 2025",
    desc: "Executive gala, brand activations and headshot lounge coverage.",
    image: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-matric-farewell-2025",
    title: "Matric Farewell — Class of '25",
    category: "Matric Farewell",
    date: "12 September 2025",
    desc: "Black-tie arrivals, group portraits, the dance under the lights.",
    image: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-wedding-2025",
    title: "Mokoena × Botha Wedding",
    category: "Weddings",
    date: "07 June 2025",
    desc: "Golden-hour vows, candlelit reception, cinematic first dance.",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-outdoor-lifestyle-2025",
    title: "Outdoor Lifestyle Shoot",
    category: "Outdoor",
    date: "22 July 2025",
    desc: "Golden plains, dust trails, editorial portraits under wide skies.",
    image: "https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-baby-shower-2025",
    title: "Naledi’s Baby Shower",
    category: "Baby Showers",
    date: "03 August 2025",
    desc: "Soft pastels, gentle laughter, quiet moments of anticipation.",
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-engagement-2025",
    title: "Thabo & Refilwe — Engagement",
    category: "Weddings",
    date: "19 October 2025",
    desc: "A sunset proposal, real tears, real joy — frame by frame.",
    image: "https://images.unsplash.com/photo-1529636798458-92182e662485?w=1400&q=85&auto=format&fit=crop",
  },
  {
    id: "evt-promo-event-2025",
    title: "Brand Promotional Launch",
    category: "Promotional Events",
    date: "11 November 2025",
    desc: "Product reveal, influencer coverage, fully-edited highlight reel.",
    image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1400&q=85&auto=format&fit=crop",
  },
];

export const EVENT_CATEGORIES = [
  "All",
  "Sports",
  "Corporate",
  "Weddings",
  "Matric Farewell",
  "Baby Showers",
  "Outdoor",
  "Promotional Events",
];

export const SERVICE_CATEGORIES_FORM = [
  "Sports Events",
  "Corporate Events",
  "Baby Showers",
  "Engagements",
  "Weddings",
  "Matric Farewells",
  "Outdoor Activities",
  "Individual Photoshoots",
  "Business Photography",
  "Lodge Photography",
  "Promotional Videos",
  "Business Intro Videos",
  "Event Videos",
];

export const CONTACT_INFO = {
  email: "hello@welkombiz.co.za",
  phone: "+27 00 000 0000",
  whatsapp: "+27 00 000 0000",
  location: "Welkom, Free State — Goldfields, South Africa",
  hours: "Mon – Sat · 08:00 – 18:00",
};
